/* eslint-disable no-unused-vars */
import { Dialog } from '@headlessui/react'
import React, { useRef, useState } from 'react'
import axios from '../../axios'

function AffiliateRewardModal(props) {
    let completeButtonRef = useRef(null)
    const [loading, setLoading] = useState(false)
    console.log(props.awarded)

    const RewardUser = async () => {
        setLoading(true)
        try {
            axios.post(`https://api-hamma-f0bcaabf77ea.herokuapp.com/affilate/approve-award/${props.id}/`).then(res => {
                console.log(res)
                props.setIsOpen(false)
                window.location.reload()
            }).catch(err => {
                console.log(err)
                alert("Failed")
            })
        } catch (error) {
            
        }
    }

    return (

        <Dialog
            open={props.isOpen}
            initialFocus={completeButtonRef}
            onClose={() => props.setIsOpen(false)}
            className="relative z-50 "
            as="div"
        >
            {/* The backdrop, rendered as a fixed sibling to the panel container */}
            <div className="fixed inset-0 bg-[#15151566]" aria-hidden="true" />

            {/* Full-screen container to center the panel */}
            <div className="fixed inset-0 flex items-center justify-center">
                {/* The actual dialog panel  */}

                <Dialog.Panel className="mx-auto lg:w-[38.3125rem] w-[95%] flex flex-col items-center bg-inherit rounded-[1.25rem] lg:p-[1.5rem]">
                    <div className='bg-white w-[100%] flex flex-col rounded-[0.75rem] p-[1.5rem]'>
                        <h1 className='font-poppins font-semibold text-[#161616] text-center mb-[1rem] py-[1rem] border-b'>{props.rank === "first" ? "1st" : props.rank === "second" ? "2nd" : "3rd"} Place Rewards</h1>

                        <p className='font-poppins font-semibold text-[#161616] text-center mb-[1rem]'>Cash Prize</p>
                        {props.data && props.rank && <p className='font-poppins font-medium text-[1.5rem] text-[#161616] text-center'>N{Number(props?.data[0][props?.rank]).toLocaleString()}</p>}
                        {props.awarded === false && <button onClick={RewardUser} className='bg-[#0FB23C] rounded-[12px] px-[2rem] mt-3 mx-auto py-[12px] text-white font-poppins font-semibold'>{loading ? "Please wait..." : "Approve Reward"}</button>}
                        <p
                            ref={completeButtonRef}
                            onClick={() => props.setIsOpen(false)}
                            className="hidden font-poppins text-[#BE8688] text-[1.25rem] font-medium"
                        >
                        </p>
                    </div>
                    <div onClick={() => props.setIsOpen(!props.isOpen)} className='bg-white cursor-pointer rounded-full w-[3.125rem] h-[3.125rem] flex items-center justify-center mt-[2rem]'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                            <path d="M18.8002 5.70998C18.7077 5.61728 18.5978 5.54373 18.4768 5.49355C18.3559 5.44337 18.2262 5.41754 18.0952 5.41754C17.9643 5.41754 17.8346 5.44337 17.7136 5.49355C17.5926 5.54373 17.4827 5.61728 17.3902 5.70998L12.5002 10.59L7.61022 5.69998C7.51764 5.6074 7.40773 5.53396 7.28677 5.48385C7.1658 5.43375 7.03615 5.40796 6.90522 5.40796C6.77429 5.40796 6.64464 5.43375 6.52368 5.48385C6.40272 5.53396 6.29281 5.6074 6.20022 5.69998C6.10764 5.79256 6.0342 5.90247 5.9841 6.02344C5.93399 6.1444 5.9082 6.27405 5.9082 6.40498C5.9082 6.53591 5.93399 6.66556 5.9841 6.78652C6.0342 6.90749 6.10764 7.0174 6.20022 7.10998L11.0902 12L6.20022 16.89C6.10764 16.9826 6.0342 17.0925 5.9841 17.2134C5.93399 17.3344 5.9082 17.464 5.9082 17.595C5.9082 17.7259 5.93399 17.8556 5.9841 17.9765C6.0342 18.0975 6.10764 18.2074 6.20022 18.3C6.29281 18.3926 6.40272 18.466 6.52368 18.5161C6.64464 18.5662 6.77429 18.592 6.90522 18.592C7.03615 18.592 7.1658 18.5662 7.28677 18.5161C7.40773 18.466 7.51764 18.3926 7.61022 18.3L12.5002 13.41L17.3902 18.3C17.4828 18.3926 17.5927 18.466 17.7137 18.5161C17.8346 18.5662 17.9643 18.592 18.0952 18.592C18.2262 18.592 18.3558 18.5662 18.4768 18.5161C18.5977 18.466 18.7076 18.3926 18.8002 18.3C18.8928 18.2074 18.9662 18.0975 19.0163 17.9765C19.0665 17.8556 19.0922 17.7259 19.0922 17.595C19.0922 17.464 19.0665 17.3344 19.0163 17.2134C18.9662 17.0925 18.8928 16.9826 18.8002 16.89L13.9102 12L18.8002 7.10998C19.1802 6.72998 19.1802 6.08998 18.8002 5.70998Z" fill="#161616" />
                        </svg>
                    </div>
                </Dialog.Panel>
            </div>
        </Dialog>

    )
}

export default AffiliateRewardModal